<template>
  <v-container fluid pa-3 background class="contain_width">
    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="SearchData"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top:7px;color:#fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>

    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>

    <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter">
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>
    <filter-component :json_data="form_filter_data" v-on:set="onCloseFormDialog" />
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="SearchData"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="SearchData"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12 v-if="permission_edit == true || admin == 'true'">
        <v-tooltip top>
          <v-btn
            slot="activator"
            color="primary"
            dark
            fixed
            bottom
            right
            fab
            style="margin-top:50px;margin-bottom:50px;margin-right:-50px;"
            @click="onHandleDialog(true, 'create', null)"
          >
            <v-icon>fa-plus</v-icon>
          </v-btn>
          <span>{{$t('create')}}</span>
        </v-tooltip>
      </v-flex>
      <v-layout
        row
        align-center
        text-xs-center
        style="margin-top:5rem;margin-bottom:15rem"
        v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer">
          <v-tooltip top>
            <template slot="activator">
              <div
                @click="onHandleDialog(true, 'create', null)"
                style="padding-top:40px;padding-bottom:40px;"
              >
                <v-icon style="font-size:80px;" color="blue">fa fa-plus</v-icon>
                <h3 class="headline mb-0" style="color:#2195F3;">{{$t('menu.CommissionCreate')}}</h3>
              </div>
            </template>
            <span>{{$t('ClickFor')}} {{$t('menu.CommissionCreate')}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex
            lg6
            md6
            sm12
            xs12
            pa-1
            v-for="(item, index) in table_data"
            :key="index"
            @click="''"
          >
            <v-card class="coco-box-shadow">
              <v-layout row wrap class="coco-list-layout" pa-3>
                <v-flex lg1 md1 sm1 xs3 text-xs-center style="margin:auto">
                  <v-icon :size="50" style="color:#03A9F4;">fas fa-file-invoice</v-icon>
                </v-flex>
                <v-flex lg8 md9 sm8 xs7>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <span class="coco-list-label-text">
                        {{$t('DocumentID')}}:
                        <span>{{isEmpty(item.docNo)? item.docNo : 'emp_code'}}</span>
                      </span>
                    </v-flex>
                    <v-flex xs12 md6 sm6>
                      <span class="coco-list-label-text">
                        {{$t('branch')}}:
                        <span>
                          {{isEmpty(item.branchCode)? item.branchCode
                          : 'branch'}}
                        </span>
                      </span>
                    </v-flex>
                    <v-flex xs12 md6 sm6>
                      <span class="coco-list-label-text">
                        {{$t('Department')}}:
                        <span>
                          {{isEmpty(item.departmentCode) ?
                          item.departmentCode : 'departmentCode'}}
                        </span>
                      </span>
                    </v-flex>
                    <v-flex xs12 md6 sm6>
                      <span class="coco-list-label-icon">
                        <v-icon>access_time</v-icon>
                        <span>{{formatDate(item.effectDate)}}</span>
                      </span>
                    </v-flex>
                    <v-flex xs12 md6 sm6>
                      <span
                        class="coco-list-label-icon"
                        v-show="(item.remark != '' && item.remark != undefined && item.remark != null)"
                      >
                        <v-icon>info</v-icon>
                        <span>{{item.remark}}</span>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex lg2 md1 sm1 xs2>
                  <v-layout row wrap>
                    <v-flex lg2 md2 sm2 xs2 text-xs-right style="margin:auto;">
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-menu offset-y>
                          <template slot="activator">
                            <v-btn icon style="color:rgba(0,0,0,0.54)">
                              <v-icon>fas fa-ellipsis-v</v-icon>
                            </v-btn>
                          </template>
                          <v-card class="pa-0" max-width="344">
                            <v-card-title
                              class="setbox"
                              v-if="permission_edit == true || admin == 'true'"
                            >
                              <v-btn
                                color="orange"
                                slot="activator"
                                flat
                                @click="onHandleDialog(true,'update',item)"
                              >
                                <v-icon>edit</v-icon>
                                <span>{{$t('edit')}}</span>
                              </v-btn>
                            </v-card-title>
                            <v-card-title
                              class="setbox"
                              v-if="permission_edit == true || admin == 'true'"
                            >
                              <v-btn color="red" flat @click="deleteItem(item)">
                                <v-icon>delete</v-icon>
                                <span>{{$t('delete')}}</span>
                              </v-btn>
                            </v-card-title>
                          </v-card>
                        </v-menu>
                      </v-card-actions>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-layout row wrap my-2></v-layout>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <v-dialog v-model="delDialogStatus" persistent max-width="300">
          <v-card>
            <v-toolbar dark color="blue d-1">
              <v-toolbar-title>
                <v-icon :size="20" class="px-2">fa-question-circle</v-icon>
                <span>{{$t('info.confirm_delete')}}</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text style="padding:15px !importtant;">
              <v-layout row wrap>
                <v-flex xs12 pa-3>
                  ต้องการลบข้อมูลเอกสารเบี้ยขยัน
                  <br />
                  เลขที่เอกสาร : {{delDialog.name}}
                  <br />
                   ใช่หรือไม่?
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-layout row wrap>
                <v-flex xs6 pa-1>
                  <v-btn
                    color="error"
                    outline
                    block
                    @click="delDialogStatus = false"
                  >{{$t('cancel')}}</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="success" outline block @click="onDelete()">{{$t('submit')}}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <!-- FrmDialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="dialog_data" v-on:close-dialog="onCloseDialog" />
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import FrmDialog from "./FormDialog";
import Empimage from "../../components/getempimage.vue";
import Utils from "@/utils/";
import moment, { locale } from "moment";
import $ from "jquery";
import FilterComponent from "./Filter";
import UserService from "@/services/UserService";

export default {
  data: () => ({
    SearchData: "",
    show_search: false,
    dialog_data: {
      status: false,
      save_type: String,
      data: Object,
    },
    totalPages: 0,
    table_data: [],
    pageActive: 1,

    processing: false,
    canLoadMore: true,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      name: "",
      time: "",
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    form_filter_data: {
      status: false,
    },
    form_dialog_data: {
      status: false,
    },
    permission_edit: false,
    permission_view: false,
    admin: false,
    empCode: localStorage._empcode,
    permission: [],
 
  }),
  created: async function () {
    this.admin = localStorage._is_admin;
    this.getCommissionList();
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    await this.checkpermission("CommissionList");

    console.log(this.check_permission);

    this.commitSetToolbar({
      patternTool: "0",
    });
    this.$store.watch(
      (state) => {
        state.filter.SelectBranch;
        state.filter.SelectDepartment;
        state.filter.SelectPosition;
        state.filter.SearchData;
        state.filter.FromDate;
        state.filter.ToDate;
      },
      () => {},
      {
        deep: true,
      }
    );
  },
  destroyed: function () {
    this.commitToggleAlertDialog({
      status: false,
      message: Object,
    });
  },
  components: {
    FrmDialog,
    FilterComponent,
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "FromDate",
      "ToDate",
    ]),
    ...mapState("app", ["showLoading", "formatDates"]),
    ...mapState("filter", ["Employee_List"]),
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter"]),
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),

    checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
               console.log(element.module_name);
                 if(page == element.module_name){
                   
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    onCloseDialog() {
      this.pageActive = 1;
      this.table_data = [];
      this.dialog_data.status = false;
      this.getCommissionList();
      
    },

    onCloseFormDialog(value) {
      this.form_dialog_data.status = false;
      this.onload = true;
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data,
      };
    },
    onHandleAlert(status, message) {
      this.alert_data = {
        status: true,
        message: err,
      };
    },
    showFilter(status) {
      this.form_filter_data = {
        status: status,
        data: 1,
      };
    },
    getCommissionList() {
      let searchVal = "";
      let department = "";
      let branch = "";
      this.commitSetShowLoading(true);
      if (this.SearchData == undefined) {
        searchVal = "";
      } else {
        searchVal = this.SearchData;
      }
      if (this.department == "All") {
        department = "";
      } else {
        department = this.SearchData;
      }
      if (this.branch == "All") {
        branch = "";
      } else {
        branch = this.SearchData;
      }
      this.commitSetShowLoading(true);
      DocumentService.getCommissionList(this.Search_data,
        branch,
        department,
        this.pageActive)
        .then(res => {
          this.table_data = res.data.content;
          console.log(res)
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
      this.commitSetShowLoading(false);
      //this.table_data = this.data.content;
      console.log(this.table_data);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatDate(newDate) {
      return moment(newDate).format("DD/MM/YYYY");
    },
     showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.docNo;
      this.delDialog.emp_code = data.emp_code ;
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteCommission(this.delDialog.name)
        .then(res => {
          this.showSnackBar("delete success", "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getCommissionList();
          this.delDialogStatus = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({ status: true, message: err.response.data
          });
        });
    },
  },
};
</script>
<style >
.setbox{
padding: 0px !important;
text-align: left;
width: 100px;
}
</style>
